module.exports = __webpack_public_path__ + "./images/cc49016d6a4997268fc8739d985b7c4e.webp";